import React from 'react';
import Layout from '../components/Layout';

const AboutUs = () => {
  return (
    <Layout>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-blue-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <img
                src="/images/kay-hero.jpg"
                alt="Kay Ruymaekers"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Hey, ik ben Kay!</h2>
            <div className="text-center space-y-4 text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
              <p>
                Als grote dierenvriend heb ik een bijzondere liefde voor paarden.
              </p>
              <p>
                De evolutie die ik als "paardenmens" heb meegemaakt heeft mijn huidige manier van werken met paarden gevormd.
              </p>
              <p>
                Deze visie deel ik heel graag met jullie.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Waarom Horse Agility Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Waarom Horse Agility?</h2>
            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl">
              Mijn lieve Athena is altijd een brokkenpiloot geweest en door de blessures werkten we meer en meer aan de hand. Tijdens mijn zoektocht naar grondwerk ontdekte ik Horse Agility en ik werd verliefd op de sport.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mt-4 max-w-3xl">
              Ondanks dat we niet meer actief gingen rijden ontstonden er toch nieuwe en leuke doelen om naartoe te werken.
            </p>
          </div>
        </div>
      </section>

      {/* Waarom anderen helpen Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Waarom anderen helpen?</h2>
            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl">
              Dankzij mijn kleine Honey en haar inzet heb ik een stem gekregen in de paardenwereld. We reizen met Showteam Honey & Beauty de Benelux rond om mensen te inspireren en samen werden we Reserve World Champion Liberty Trophy 2018 en 2023 en European Champion Liberty Trophy 2019 doorheen onze deelnames aan de competities van The International Horse Agility Club.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mt-4 max-w-3xl">
              Deze mooie resultaten zorgden ervoor dat we de kans kregen om Accredited Horse Agility Trainer te worden. De club wordt niet alleen gerund door de uitvinder van deze tak van de paardensport maar staat ook achter het belang van het paard-vriendelijk uitoefenen ervan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mt-4 max-w-3xl">
              Ik ben heel blij dat wij deel kunnen uitmaken van het verspreiden van die positieve boodschap in de paardenwereld.
            </p>
          </div>
        </div>
      </section>

      {/* Positiviteit Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Positiviteit is het sleutelwoord...</h2>
            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Hier op mijn site vertel ik je meer over mijn manier van trainen. Kan je samen met mij aan de slag en stel ik je met veel plezier voor aan mijn paarden en ons showteam.
            </p>
          </div>
        </div>
      </section>

    </Layout>
  );
};

export default AboutUs;

